var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-checkbox-grid-list"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"cf-c-checkbox-grid-list__item cf-u-mr-xxl"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }